import { awinGatewayBaseUrl } from 'environments/environment';

export const ancillaryServiceEndpoints: Record<string, string> = {

  accountPermissionsUrl: `${awinGatewayBaseUrl}/backend/account-permissions-api/users/:userId/accounts`,

  advertiserLogoUrl: `https://ui.awin.com/images/upload/merchant/profile/:advertiserId.png`,
  advertiserLogoFallbackUrl: 'https://images.awin.com/darwin/profiles/profile_default.gif',

  advertiserTrackingLinkBuilderUrl: `${awinGatewayBaseUrl}/backend/linkbuilder-api/merchant/:advertiserId/generate`,

  gatekeeperUrl: `${awinGatewayBaseUrl}/backend/gatekeeper-api/features`,

  alertsUrl: `${awinGatewayBaseUrl}/dashboard-api/:accountType/:id/notification`,
  closeAlertUrl: `${awinGatewayBaseUrl}/user-message/xhr-remind-me`,
  sessionTokenUrl: `${awinGatewayBaseUrl}/navigation/session`,

  publisherMerchantAlertOptionsUrl: `${awinGatewayBaseUrl}/awin/affiliate/:publisherId/settings/merchant-alert-options`,
  publisherContactSettingsUrl: `${awinGatewayBaseUrl}/awin/affiliate/:publisherId/settings/contact`

};
